import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel'

ReactGA.initialize('UA-81699076-3', {
})

ReactPixel.init('766256907659495', undefined, {
    autoConfig: true,
    debug: false
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
